import { getData } from "src/utils/axios/serverHelper";
import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";

import { WMS2010_R01Dto } from "./Dto_WMS2010_R01";
import { WMS2010_R01Filter } from "./Store_WMS2010_R01";

const baseUrl = `${config.apiUrl}/WMS2010_R01/search`;

// 통합 재고 조회 API (view 파라미터로 탭별 데이터 분기)
export const getWMS2010_R01Data = async (view: string, params: Partial<WMS2010_R01Filter>) => {
	const url = `${baseUrl}`;
	const requestParams = {
		logicCenter: params.logicCenter || undefined,
		warehouseCd: params.warehouseCd || undefined,
		itemCd: params.itemCd || undefined,
		itemGroup: params.itemGroup || undefined,
		brandCd: params.brandCd || undefined,
		view,
		option: 'search', // LIMIT 제한 해제를 위한 옵션 추가
	};

	return await getData<ResponseDto<WMS2010_R01Dto[]>>(url, { params: requestParams });
};

// 통합 Excel 내보내기 API
export const exportWMS2010_R01Excel = async (view: string, params: Partial<WMS2010_R01Filter>) => {
	const url = `${baseUrl}/excel`;
	const requestParams = {
		logicCenter: params.logicCenter || undefined,
		warehouseCd: params.warehouseCd || undefined,
		itemCd: params.itemCd || undefined,
		itemGroup: params.itemGroup || undefined,
		brandCd: params.brandCd || undefined,
	};

	// view는 쿼리 파라미터로, 나머지는 body로 전송
	return await getData<ResponseDto<string>>(url, {
		params: { ...requestParams, view },
	});
};

// 하위 호환을 위한 기존 함수들 (deprecated)
export const getWMS2010_R01List = async (searchType: string, params: Partial<WMS2010_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/${searchType}`;
	const requestParams = {
		logicCenter: params.logicCenter || undefined,
		warehouseCd: params.warehouseCd || undefined,
		itemCd: params.itemCd || undefined,
		itemGroup: params.itemGroup || undefined,
		brandCd: params.brandCd || undefined,
		listLength,
		view: 'ALL'
	};

	return await getData<ResponseDto<WMS2010_R01Dto[]>>(url, { params: requestParams });
};
